"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.frameCCLoaderBase = void 0;
const routesCC_1 = require("../routesCC");
const initializer_1 = require("../../initializer");
const contactCenter_1 = require("../../contactCenter");
const frameBaseLoaderCommon_1 = require("../frameBaseLoaderCommon");
const frameCCLoaderBase = async (params) => {
    if ((0, contactCenter_1.isDRPicasoRoute)()) {
        await initializer_1.DRPicasoAuthenticator.loginAgent();
    }
    else if ((0, contactCenter_1.isAssistedLoginRoute)()) {
        await initializer_1.AssistedAuthenticator.login();
    }
    else if (!(0, contactCenter_1.isDevelopmentLogicCCRoute)()) {
        if (!initializer_1.CCDevSession.isValid() && !initializer_1.DRPicasoSession.isValid() && !initializer_1.AssistedSession.isValid()) {
            await initializer_1.USDAuthenticator.login();
        }
    }
    (0, frameBaseLoaderCommon_1.frameLoaderBaseCommon)(params, routesCC_1.Router, routesCC_1.Routes);
};
exports.frameCCLoaderBase = frameCCLoaderBase;
//# sourceMappingURL=index.js.map